import Vue from 'vue'
Vue.directive('has', {
  inserted: function (el, binding) {
    if (!permissionJudge(binding.value)) {
      el.parentNode.removeChild(el)
    }
    function permissionJudge(value) {
      let list = JSON.parse(localStorage.getItem('permissionList'))
      if (list !== null && list.length && list.length > 0) {
        for (let item of list) {
          if (item.name == value) return true
        }
        return false
      }
    }
  },
})
